import { useContext, useState } from "react";

/** IMPORTS */
import { AuthContext } from "../Global/AuthContext";
import { TEXT_BTN, TYPES_ALERTS, TYPE_TF_PO, TEXT_REPORT_PO } from "../Constants/Const";
import { TransitionAlerts } from "../Global/AlertComonent";
import { TitleComponent } from "../Global/TitleReportComponent";

/** MUI */
import { Autocomplete, Button, Divider, Grid, Paper, TextField } from "@mui/material";

// # region CONST
const INIT_TICKET = {
    unidad : null,
    dataUnidad: null,
    dataChofer: null,
    chofer: null,
    description: '',
    number_status: 1,
    status: 'EN PROCESO'
}

const INIT_OPTIONS ={
    bus: [],
    chofer: []
}

//  endregion CONST

export function PreOrderComponent(){
    
        const {addReport, report} = useContext(AuthContext);

        const [dataTicket, setDataTicket] = useState(INIT_TICKET);

        const [options] = useState(INIT_OPTIONS);

        const [folio, setFolio] = useState(report?.length+1);

        /** Function to save data to report failed(unidad, chofer, descripcion de la falla)
         * 
         * @param {string} type - Type to textfile for save on hook.
         */
        const handlingTicket = (type) => (event, value) =>{
            
            if(type === TYPE_TF_PO.unidad){
                
                setDataTicket((oldData)=>{
                    return{
                        ...oldData,
                        unidad : value?.id? value.id:null,
                        dataUnidad: value
                    }
                });
            }
            else if(type === TYPE_TF_PO.desc){
                
                setDataTicket((oldData)=>{
                    return{
                        ...oldData,
                        description: event.target.value
                    }
                });
            }
            else if(type === TYPE_TF_PO.chofer){
                setDataTicket((oldData)=>{
                    return{
                        ...oldData,
                        chofer : value?.id? value.id:null,
                        dataChofer: value
                    }
                });
            }
            
        }

        const handlingCreateReport = () =>{
            if(!dataTicket.unidad){
                TransitionAlerts({open:true,
                    message:"Selecciona una unidad",
                    typeAlert:TYPES_ALERTS.warning});
                return;
            }
            if(!dataTicket.chofer){
                TransitionAlerts({open:true,
                    message:"Selecciona al chofer que reporta",
                    typeAlert:TYPES_ALERTS.warning});
                return;
            }
            if(dataTicket.description.length === 0){
                TransitionAlerts({open:true,
                    message:"Describe el problema",
                    typeAlert:TYPES_ALERTS.warning});
                return;
            }

            let newDataReport = [
                ...report,
                {
                id: folio,
                datosChofer: dataTicket.dataChofer,
                datosUnidad: dataTicket.dataUnidad,
                descripcion: dataTicket.description,
                }
            ]

            addReport(newDataReport)
            setDataTicket(INIT_TICKET);
            setFolio(folio+1);
            TransitionAlerts({open:true,
                message:"Resporte creado",
                typeAlert:TYPES_ALERTS.success});
        }

        return(
                <Paper elevation={10}>

                    <TitleComponent title={TEXT_REPORT_PO.title} />


                    <Grid container spacing={1}
                        direction="row"
                        justifyContent="center"
                        alignItems="center">

                            {/* # region TEXT FIELD UNIT */}
                            <Grid item xs={6}>

                                <Autocomplete
                                disablePortal
                                options={options.bus}
                                onChange={handlingTicket(TYPE_TF_PO.unidad)}
                                value={options.bus.find((option) => option && option?.id === dataTicket.unidad) || null}
                                renderInput={
                                        (params) => <TextField margin="normal" variant="filled" {...params} label={TEXT_REPORT_PO.unit}/>
                                }
                                />

                            </Grid>
                            {/* # endregion TEXT FIELD UNIT */}

                            {/* # region TEXT FIELD CHOFER */}
                            <Grid item xs={6}>

                                <Autocomplete
                                    disablePortal
                                    options={options.chofer}
                                    onChange={handlingTicket(TYPE_TF_PO.chofer)}
                                    value={options.chofer.find((option) => option && option?.id === dataTicket.chofer) || null}
                                    renderInput={
                                            (params) => <TextField margin="normal" variant="filled" {...params} label={TEXT_REPORT_PO.chofer}/>
                                    } />
                                
                            </Grid>
                            {/* # endregion TEXT FIELD CHOFER */}

                            {/* # region TEXT FIELD DESCRIPTION */}
                            <Grid item xs={12}>

                                <TextField
                                    margin="normal"
                                    fullWidth
                                    id="filled-multiline-flexible"
                                    label={TEXT_REPORT_PO.description}
                                    value={dataTicket.description}
                                    onChange={handlingTicket(TYPE_TF_PO.desc)}
                                    multiline
                                    maxRows={6}
                                    variant="filled"
                                    />

                            </Grid>
                            {/* # endregion TEXT FIELD DESCRIPTION */}

                            <Grid item xs={12}>

                                <Divider/>

                            </Grid>


                            <Grid item xs={12} container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center">

                                        <Button style={{marginRight: "1vh"}} variant="outlined" color="error"
                                                onClick={()=>setDataTicket(INIT_TICKET)}
                                            >{TEXT_BTN.cancel}</Button>

                                        <Button variant="outlined" color="success"
                                                onClick={handlingCreateReport}
                                            >{TEXT_BTN.accepted}</Button>

                            </Grid>
                                        
                    </Grid>

                </Paper>
        );
}